import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import CateringPage from './pages/CateringPage';
import PageNotFound from './pages/PageNotFound';
import ReactGA from 'react-ga4';

 const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <HomePage></HomePage>
    )
  },
   {
    path: '/catering',
    element: (
      <CateringPage></CateringPage>
    )
  },
  {
    path: '*',
    element: (
      <PageNotFound></PageNotFound>
    )
  },
 ]);

 ReactGA.initialize("G-LPN82WKDK4");
function App() {
  return (
    <div className="App">
      <RouterProvider router={router}/>
    </div>
  );
}

export default App;
